import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IndexedDBService } from "../services/indexedDbService";

const DB_KEY = "creditDraft";
const db = new IndexedDBService();

export const useCreditDraftStore = create(
  devtools((set, get) => ({
    draft: null,
    loading: false,

    loadDraft: async () => {
      const existing = await db.getItemByKey("creditDraft");
      if (existing?.value) {
        set({ draft: existing.value });
      } 
      // else {
      //   // valores iniciales
      //   const initialDraft = { checkFirmaElectronica: true };
      //   set({ draft: initialDraft });
      //   await db.setItemByKey("creditDraft", initialDraft);
      // }
    },

    saveDraft: async (partialOrFullDraft) => {
      const current = get().draft || {};
      const updated = { ...current, ...partialOrFullDraft, updatedAt: new Date().toISOString() };
      set({ draft: updated });
      try {
        await db.setItemByKey("creditDraft", updated); // persiste
      } catch (err) {
        console.error("Error guardando draft en IDB:", err);
      }
    },

    // 🔹 Limpiar draft
    clearDraft: async () => {
      await db.deleteItem(DB_KEY);
      set({ draft: null });
    },
  }))
);
